export default __webpack_public_path__ + "static/media/ethiopia.ab4494a2.jpg";